import {
    PlacementType,
    PortalEnumValueToName,
    ReferralConsideration,
    ServiceType,
    SPLIT_DELIMITER
} from '../const';
import {tryFormatLocalDate} from "../../common/util/date";
import {format, subMonths} from "date-fns";
import {LOCAL_DATE_FORMAT} from "../../common";

export type NavigationFilterValue = {
    provider: string
    preferredCity: string;
    counties: string;
    serviceLocationTypes: string;
    scopeOfService: string;
    escalationLevels: string;
    referralConsiderations: string;
    requiredLanguage: string;
    serviceType: string
    referralSubmittedFrom: Date | null;
    referralSubmittedTo: Date | null;
}

export function isFilterValueEmpty(val: NavigationFilterValue): boolean {
    return val.provider === ""
        && val.preferredCity === ""
        && val.scopeOfService === ""
        && val.escalationLevels === ""
        && val.referralConsiderations === ""
        && val.requiredLanguage === ""
        && val.serviceType === ""
        && val.serviceLocationTypes === ""
        && val.counties === ""
        && val.referralSubmittedFrom === null
        && val.referralSubmittedTo === null;
}

export type NavigationFilterValueParsed = {
    matchedProvider: string[] | undefined;
    escalationLevel: number[] | null | undefined;
    placementType: string[] | undefined;
    referralConsideration: string[] | undefined;
    serviceType: string[] | undefined;
    language: string[] | undefined;
    city: string[] | undefined;
    counties: string[] | undefined;
    serviceLocationType: string[] | undefined;
    referralSubmittedFrom: string | null | undefined;
    referralSubmittedTo: string | null | undefined;
}

function filterByReferralConsiderations(inputs: Array<string>): Array<string> {
    return inputs.reduce((res, input) => {
        if (Object.values(ReferralConsideration).includes(input as ReferralConsideration)) {
            res.push(PortalEnumValueToName.get(input)!);
        }

        return res;
    }, Array<string>());
}

function filterByPlacementType(inputs: Array<string>): Array<string> {
    return inputs.reduce((res, input) => {
        if (Object.values(PlacementType).includes(input as PlacementType)) {
            res.push(PortalEnumValueToName.get(input)!);
        }

        return res;
    }, Array<string>());
}

function filterByServiceType(inputs: Array<string>): Array<string> {
    return inputs.reduce((res, input) => {
        if (Object.values(ServiceType).includes(input as ServiceType)) {
            res.push(PortalEnumValueToName.get(input)!);
        }

        return res;
    }, Array<string>());
}

export function filterValueParse(filter?: NavigationFilterValue): NavigationFilterValueParsed {
    if (!filter) {
        return {
            escalationLevel: null,
            placementType: [],
            referralConsideration: [],
            serviceType: [],
            language: undefined,
            city: undefined,
            matchedProvider: undefined,
            serviceLocationType: [],
            counties: [],
            referralSubmittedFrom: format(subMonths(new Date(), 1), LOCAL_DATE_FORMAT),
            referralSubmittedTo: undefined
        };
    }

    const escalationLevels = filter.escalationLevels
        .split(SPLIT_DELIMITER)
        .filter((i) => i !== '')
        .map((i) => Number(i))
    return {
        matchedProvider: filter.provider.split(SPLIT_DELIMITER).filter((i) => i !== ''),
        escalationLevel: escalationLevels?.length === 0 ? null : escalationLevels,
        placementType: filterByPlacementType(filter.scopeOfService.split(SPLIT_DELIMITER)),
        referralConsideration: filterByReferralConsiderations(filter.referralConsiderations.split(SPLIT_DELIMITER)),
        serviceType: filterByServiceType(filter.serviceType.split(SPLIT_DELIMITER)),
        language: filter.requiredLanguage.split(SPLIT_DELIMITER).filter(((i) => i !== '')),
        city: filter.preferredCity.split(SPLIT_DELIMITER).filter((i) => i !== ''),
        serviceLocationType: filter.serviceLocationTypes.split(SPLIT_DELIMITER).filter((i) => i !== ''),
        counties: filter.counties.split(SPLIT_DELIMITER).filter((i) => i !== ''),
        referralSubmittedTo: tryFormatLocalDate(filter.referralSubmittedTo ?? null),
        referralSubmittedFrom: tryFormatLocalDate(filter.referralSubmittedFrom ?? null)
    };
}
